import React from 'react';

import { type CustomPostField, CustomPostFieldTypes } from 'common/api/resources/postFields';
import { Select } from 'common/uiV3/Select';

import type { Option } from 'common/ui/common/select/SelectCommon';

const DefaultGroupByOptions = [
  { label: 'Board', value: 'Board' },
  { label: 'Category', value: 'Categories' },
  { label: 'Owner', value: 'Owner' },
  { label: 'Status', value: 'Status' },
];

export enum GroupByTypes {
  default = 'default',
  customPostField = 'customPostField',
}

/**
 * @todo: This function only takes into consideration custom post fields of the type "dropdown"
 * */
export const getGroupableCustomPostFields = (customPostFields: CustomPostField[]) => {
  return customPostFields.filter(
    (customPostField) => customPostField.type === CustomPostFieldTypes.dropdown,
  );
};

export const getGroupByOptions = (customPostFields: CustomPostField[]) => {
  return DefaultGroupByOptions.concat(
    getGroupableCustomPostFields(customPostFields).map((customPostField) => ({
      label: customPostField.name,
      value: customPostField._id,
    })),
  );
};

type Props = {
  groupBy?: string;
  customPostFields: CustomPostField[];
  onGroupByChange: (option: Option | undefined) => void;
};

const AdminRoadmapGroupBy = ({ groupBy, onGroupByChange, customPostFields }: Props) => {
  const options = getGroupByOptions(customPostFields);

  const handleValueChange = (value: string | undefined) => {
    if (!value) {
      onGroupByChange(undefined);
      return;
    }

    onGroupByChange({ value, label: value });
  };

  return (
    <div className="min-w-48">
      <Select
        allowClear
        onValueChange={handleValueChange}
        options={options}
        placeholder="Group By"
        value={groupBy}
        fullWidth
      />
    </div>
  );
};

export default AdminRoadmapGroupBy;
